import {
    EEasycarsParameters,
    EParameters,
    getCaseInsensitiveParam,
    getCaseInsensitiveParamFromList,
    getParameters,
} from '@/utils/setParametersFromParams';

// Which vehicle listing the widget is sitting on.
//
// For an iframe the partner page's path is usually unavailable (see embedPage.ts),
// but partners already put the vehicle on the iframe src because the calculator
// needs it. On a dealer site that identifies the page as well as a path would —
// and unlike a path it survives the site being rebuilt.
//
// A strict whitelist. The same query strings also carry dealerEmail, leadEmail
// and dealerPhone, and none of that belongs in this collection.
export type ListingIdentity = {
    listingVin?: string;
    listingStockNumber?: string;
    listingNvic?: string;
};

// Caps mirror the API contract. Anything longer is not an identifier.
const MAX_VIN = 40;
const MAX_STOCK_NUMBER = 60;
const MAX_NVIC = 20;

function clean(value: string | null, max: number): string | undefined {
    const trimmed = (value ?? '').trim();
    if (!trimmed || trimmed.length > max) return undefined;
    return trimmed;
}

export function getListingIdentity(): ListingIdentity {
    try {
        const params = getParameters();
        const identity: ListingIdentity = {};

        // VINs are case-insensitive by definition; upper-casing keeps one vehicle
        // from grouping as two. Upper-cased before the length check because a few
        // characters grow when upper-cased, and the API cap is on what is sent.
        const vin = clean(getCaseInsensitiveParam(params, EParameters.VIN)?.toUpperCase() ?? null, MAX_VIN);
        if (vin) identity.listingVin = vin;

        // Easycars-style feeds spell it `stocknumber`; the lookup is
        // case-insensitive anyway, but the list mirrors the vehicle prefill.
        const stockNumber = clean(
            getCaseInsensitiveParamFromList(params, [
                EParameters.STOCK_NUMBER,
                EEasycarsParameters.STOCK_NUMBER,
            ]),
            MAX_STOCK_NUMBER
        );
        if (stockNumber) identity.listingStockNumber = stockNumber;

        const nvic = clean(getCaseInsensitiveParam(params, EParameters.NVIC), MAX_NVIC);
        if (nvic) identity.listingNvic = nvic;

        return identity;
    } catch (error) {
        return {};
    }
}
